// Modules
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';

import {
  getNextRecurrenceDate,
  getRecurrenceDescription
} from 'utils/form-utils';
import { longDate, superShortDate } from 'utils/format-utils';
import { preventDefault, stopPropagation } from 'utils/event-handlers';
import DatePicker from 'components/widgets/overlays/date-picker';
import SVG from 'components/widgets/icons/svg';
import Task from 'services/data/task';
import Tooltip from 'components/widgets/overlays/tooltip';

export default class TaskDatePicker extends React.Component {
  static propTypes = {
    task: PropTypes.object,
    update: PropTypes.func
  };

  constructor() {
    super();

    this.setDates = this.setDates.bind(this);
  }

  setDates(dates) {
    const updates = {};

    if (!_.isUndefined(dates.startDate)) updates.startDate = dates.startDate;
    if (!_.isUndefined(dates.endDate)) updates.dueDate = dates.endDate;
    if (!_.isUndefined(dates.recurrence)) updates.recurrence = dates.recurrence;

    this.props.update(updates);
  }

  render() {
    const { task } = this.props;
    const isOverdue = Task.isOverdue(task);
    const isStarted = Task.isStarted(task);
    const isToday = Task.isToday(task);
    const startsToday = Task.startsToday(task);
    const daysTilDue = Task.daysTilDue(task);
    const daysTilStart = Task.daysTilStart(task);
    const recurring = _.get(task, 'recurrence.enabled');

    const tooltip = (
      <div>
        { task.startDate && <span>Start task: {longDate(task.startDate)}<br /></span> }
        <span>Task due: {longDate(task.dueDate)}</span>
        { recurring &&
          <span>
            <br />{getRecurrenceDescription(task.recurrence)}
            <br />Will recur next on: {longDate(getNextRecurrenceDate(task.recurrence, task))}
          </span>
        }
      </div>
    );

    return (
      <Tooltip onClick={stopPropagation(preventDefault(this.show))} className={classNames('task-date', 'flex flex-mobile', { today: isToday, overdue: isOverdue })} title={tooltip}>
        { task.startDate &&
          <span onClick={this.picker && this.picker.show} className="task-start-date">
            { isStarted && daysTilStart < 30 && `Started -${daysTilStart}D` }
            { isStarted && daysTilStart >= 30 && `Started ${superShortDate(task.startDate)}` }
            { startsToday && 'Started Today' }
            { !isStarted && !startsToday && daysTilStart < 30 && `Start ${daysTilStart}D` }
            { !isStarted && !startsToday && daysTilStart >= 30 && `Start ${superShortDate(task.startDate)}` }
          </span>
        }
        <DatePicker
          selectDate={this.setDates}
          startDate={task.startDate}
          endDate={task.dueDate}
          recurrence={task.recurrence}
          task={task}
          startDateLabel="When can I start?"
          endDateLabel="When is it due?"
          ref={picker => { this.picker = picker; }}
        >
          <span className="task-due-date">
            { isOverdue && 'Overdue' }
            { isToday && 'Due Today' }
            { !isOverdue && !isToday && daysTilDue < 30 && `Due ${daysTilDue}D` }
            { !isOverdue && !isToday && daysTilDue >= 30 && `Due ${superShortDate(task.dueDate)}` }
          </span>
        </DatePicker>
        { recurring &&
          <span className="task-recurrence-icon">
            <SVG src="svg/refresh.svg" />
          </span>
        }
      </Tooltip>
    );
  }
}
